import api from "./api";

export const authService = {
    async login(email, password) {
        const { data } = await api.post("/auth/login", { email, password });
        return data;
    },
    async me() {
        const { data } = await api.get("/auth/me");
        return data;
    },
    async updateMe(patch) {
        const { data } = await api.patch("/auth/me", patch);
        return data;
    },
    async changePassword(currentPassword, newPassword) {
        const { data } = await api.post("/auth/change-password", {
            current_password: currentPassword,
            new_password: newPassword,
        });
        return data;
    },
    async forgotPassword(email) {
        const { data } = await api.post("/auth/forgot-password", { email });
        return data;
    },
    async resetPassword(token, newPassword) {
        const { data } = await api.post("/auth/reset-password", {
            token,
            new_password: newPassword,
        });
        return data;
    },
};
